import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useCadreRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-cadres",
    async () => {
      return await api.cadres();
    },
    { staleTime: Infinity }
  );

  return {
    cadres: data ?? [],
    cadresLoading: isFetching,
    refetchCadresRef: refetch,
  };
}
